/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum SecurityGovernanceFeatureFlags {
    segn_2601_b_security_issues_trend = 'segn_2601_b_security_issues_trend',
    segn_2602_a_resource_detail_view = 'segn_2602_a_resource_detail_view',
    segn_2602_a_application_with_bcs_questions = 'segn_2602_a_application_with_bcs_questions',
    segn_2603_a_application_to_workload = 'segn_2603_a_application_to_workload',
    segn_2603_a_attackpath_analysis = 'segn_2603_a_attackpath_analysis'
}
